import script from "./navigationHeaderLogos.vue?vue&type=script&setup=true&lang=js"
export * from "./navigationHeaderLogos.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__